import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { HashLink as Link } from 'react-router-hash-link';

const useStyles = makeStyles(() => ({
  root: {
    fontSize: (props) => (props.small ? '0.9rem' : props.big ? '1.4rem' : '1rem'),
    cursor: 'pointer',
    textTransform: 'none',
    color: (props) => props.color,
  },
}));

const HashLink = (props) => {
  const {
    color,
    to,
    children,
    small,
    big,
    onClick,
    bold,
    smooth,
  } = props;

  const classes = useStyles({ small, color, big });
  let attrs = {
    className: classes.root,
    color,
    underline: 'always',
  };

  if (to) {
    attrs = {
      ...attrs,
      to,
      rel: 'noopener noreferrer',
      smooth,
    };
  }

  if (typeof onClick === 'function') {
    attrs = {
      ...attrs,
      onClick,
    };
  }

  return (
    <Link {...attrs}>
      { bold === false ? (children) : (<strong>{children}</strong>)}
    </Link>
  );
};

HashLink.defaultProps = {
  color: 'inherit',
  small: false,
  big: false,
  onClick: null,
  to: '',
  bold: true,
  smooth: true,
};

HashLink.propTypes = {
  color: PropTypes.string,
  to: PropTypes.string,
  children: PropTypes.node.isRequired,
  small: PropTypes.bool,
  big: PropTypes.bool,
  onClick: PropTypes.func,
  bold: PropTypes.bool,
  smooth: PropTypes.bool,
};

export default HashLink;
